import React from 'react';
import { url as urlUtils } from '@clubmed/utils';
export const HTML_ELEMENTS = {
  BLOCKQUOTE: {
    tag: 'blockquote',
    type: 'blockquote',
  },
  BREAK: {
    tag: 'br',
    type: 'break',
  },
  CODE: {
    tag: 'code',
    type: 'code',
  },
  DELETE: {
    tag: 'del',
    type: 'delete',
  },
  EMPHASIS: {
    tag: 'em',
    type: 'emphasis',
  },
  HEADING: {
    tag: 'h',
    type: 'heading',
  },
  IMAGE: {
    tag: 'img',
    type: 'image',
  },
  LINK: {
    tag: 'a',
    type: 'link',
  },
  LIST: {
    tag: 'ul',
    type: 'list',
  },
  LIST_ITEM: {
    tag: 'li',
    type: 'listItem',
  },
  PARAGRAPH: {
    tag: 'p',
    type: 'paragraph',
  },
  ROOT: {
    tag: 'root',
    type: 'root',
  },
  SPAN: {
    tag: 'span',
    type: 'span',
  },
  STRONG: {
    tag: 'strong',
    type: 'strong',
  },
  TABLE: {
    tag: 'table',
    type: 'table',
  },
  TABLE_HEAD: {
    tag: 'thead',
    type: 'tableHead',
  },
  TABLE_BODY: {
    tag: 'tbody',
    type: 'tableBody',
  },
  TABLE_ROW: {
    tag: 'tr',
    type: 'tableRow',
  },
  TABLE_CELL: {
    tag: 'td',
    type: 'tableCell',
  },
  TEXT: {
    tag: 'p',
    type: 'text',
  },
  THEMATIC_BREAK: {
    tag: 'hr',
    type: 'thematicBreak',
  },
};
export const markdownLinkRenderer =
  () =>
  ({ children, href = '' }: any) => {
    if (!urlUtils.isB2cUrl(href)) {
      return (
        <a href={href} rel="noopener noreferrer" target="_blank">
          {children}
        </a>
      );
    }

    return <a href={urlUtils.normalizeUrl(href)}>{children}</a>;
  };
export const markdownRootRenderer =
  (props: any) =>
  ({ children, node, ...othersProps }: any) => {
    return (
      <div {...props} {...othersProps}>
        {children}
      </div>
    );
  };
export const markdownRootHeadingRenderer =
  ({ hLevel, ...props }: any) =>
  ({ children, node, ...othersProps }: any) => {
    const TagName = hLevel ? `h${hLevel}` : 'h1';
    return (
      <TagName {...props} {...othersProps}>
        {children}
      </TagName>
    );
  };
